import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-freigeben';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungFreigebenEffects {

    VeranstaltungFreigeben$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNG_FREIGEBEN),
        mergeMap((x: ac.PostVeranstaltungFreigebenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungFreigeben(x.veranstaltungPhaseRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungFreigebenErfolgreichAction(result, x.veranstaltungPhaseRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungFreigebenFehlerAction(error, x.veranstaltungPhaseRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungenCommandService);
        }
        return this.service;
    }
}
